<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
      </div>
      <b-table
        :items="pendingOrders"
        :fields="pendingOrdersHeaders"
        :busy="pendingOrdersLoading"
        show-empty
        hover
        responsive
        :per-page="perPage"
        head-row-variant="info"
        table-variant="white"
        style="font-size:12px;"
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : noOrderMessage }}
          </h6>
        </template>
        <template #cell(date)="data">
          {{ formattedDate(data.item.date, "DD-MM-YYYY") }}
        </template>
        <template #cell(unitPrice)="data">
          {{ numberConverter(data.item.unitPrice) }}
        </template>
        <template #cell(totalAmount)="data">
          {{ numberConverter(data.item.totalAmount) }}
        </template>
        <template #cell(stockName)="data">
          {{data.item.stockName}}
          <p class="mb-0 fs-6" v-if="data.item.producerCode">
            Üretici Kodu :
            <span class="fw-medium fs-7">{{ data.item.producerCode }}</span>
          </p>
        </template>
        <template #cell(itemStatus)="data">
          <div style="text-align: -webkit-center;">
            <v-chip
                class="ma-2"
            >
              {{ statusCheck(data.item.itemStatus) }}
            </v-chip>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
            ></b-spinner>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../../helpers";

export default {
  components: {
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  computed: {
    ...mapState("order", ["pendingOrders", "pendingOrdersHeaders", "pendingOrdersLoading","noOrderMessage","pendingOrdersMetaData"]),
  },
  data() {
    return {
      selectRow: false,
      orderDetailDialog: false,
      orderDetailDialogData: null,
    };
  },
  methods: {
    numberConverter,
    formattedDate,
    openSiparisDetailDialog() {
      this.orderDetailDialog = true;
    },
    sortChanged(value) {
      value;
    },
    statusCheck(value) {
      switch (value) {
        case 0:
          return "Durum yok"
        case 1:
          return "Sipariş Verildi"
        case 2:
          return "Onaylandı"
        case 3:
          return "Reddedildi"
        case 4:
          return "Hazırlanıyor"
        case 5:
          return "Gönderildi"
        case 6:
          return "Teslim Edildi"
      }
    }
  },
};
</script>
